export enum SelectCWQuestionType {
  Select,
  Selected,
  SelectOne,
}
